import { Box, Button, CircularProgress, Container, Grid, Paper, TextField, Typography } from '@material-ui/core'
import { DateTimePicker } from '@material-ui/pickers'
import React, { useEffect, useState } from 'react'
import BraftEditor, { EditorState } from 'braft-editor'
import { cos } from '../../../utils/cos'
import { useParams } from 'react-router'
import * as yup from 'yup'
import { useFormik } from 'formik'
import moment from 'moment'
import { CoachCampAPI } from '../../../utils/api'
import { useFeedback } from '../../../components/Feedback'
import { useDropzone } from 'react-dropzone'

const CreateCoachCamp = () => {
    const { campId } = useParams<{ campId: string }>()
    const { showToast } = useFeedback()
    const [editorState, setEditorState] = React.useState(BraftEditor.createEditorState(null))
    const { acceptedFiles, getRootProps, getInputProps } = useDropzone()
    const [uploadImg, setUploadImg] = React.useState(false)

    const hanldeEditorChange = (state: EditorState) => {
        setEditorState(state)
    }

    const handleSubmit = (values: any) => {
        const params = {
            ...values,
            begin_time: values.begin_time.getTime(),
            end_time: values.end_time.getTime(),
            details: editorState.toHTML(),
            details_raw: editorState.toRAW()
        }
        if (campId) {
            CoachCampAPI.update(campId, params).then(res => {
                console.info(res)
                showToast('更新成功')
            }).catch(err => {
                console.info(err)
                showToast('更新失败')
            })
        } else {
            CoachCampAPI.create(params).then(res => {
                console.info(res)
                showToast('创建成功')
            }).catch(err => {
                console.info(err)
                showToast('创建失败')
            })
        }

    }

    const loadCamp = (campId: string) => {
        CoachCampAPI.get(campId).then(res => {
            if (res) {
                formik.setValues({
                    name: res.name,
                    begin_time: moment(res.begin_time).toDate(),
                    end_time: moment(res.end_time).toDate(),
                    max_enrollment_number: res.max_enrollment_number,
                    price: res.price,
                    slogan: res.slogan,
                    cover: res.cover,
                    original_price: res.original_price
                })
                if (res.details_raw) {
                    setEditorState(BraftEditor.createEditorState(res.details_raw))
                } else if (res.details) {
                    setEditorState(BraftEditor.createEditorState(res.details))
                }
            }
        }).catch(err => {
            console.info(err)
        })
    }

    useEffect(() => {
        if (campId) {
            loadCamp(campId)
        }
    }, [campId])

    useEffect(() => {
        if (acceptedFiles && acceptedFiles.length > 0) {
            setUploadImg(true)
            handleEditorUpload({
                file: acceptedFiles[0], success: res => {
                    setUploadImg(false)
                    formik.setFieldValue('cover', res.url)
                }
            })
        }
    }, [acceptedFiles])

    const handleEditorUpload = (param: {
        file: File, success: (res: {
            url: string, meta: {
                id: string
                title: string
                alt: string
                loop: boolean
                autoPlay: boolean
                controls: boolean
                poster: string
            }
        }) => void
    }) => {
        const file = param.file
        const filename = Date.now() + file.name.substr(file.name.lastIndexOf('.'))

        cos.sliceUploadFile({
            Bucket: 'video-1302643710', /* 必须 */
            Key: 'img/coach_camp/' + filename,              /* 必须 */
            Body: file,
            Region: 'ap-beijing',
            onTaskReady: function (taskId: any) {                   /* 非必须 */
                console.log(taskId);
            },
            onHashProgress: function (progressData: any) {       /* 非必须 */
                console.log(JSON.stringify(progressData));
            },
            onProgress: function (progressData: any) {           /* 非必须 */
                console.log(JSON.stringify(progressData));
            }
        }, (err: any, data: any) => {
            if (!err) {
                const url = 'https://res.add-coach.com/' + data.Key
                param.success({
                    url: url, meta: {
                        id: '',
                        title: '',
                        controls: false,
                        autoPlay: false,
                        loop: false,
                        alt: '',
                        poster: ''
                    }
                })
            }
            console.log(err || data);
        })
    }

    const validationSchema = yup.object({
        name: yup.string().max(200).required('请输入训练营名称'),
        begin_time: yup.date().typeError('请选择开始时间').required('请选择开始时间'),
        end_time: yup.date().typeError('请选择结束时间').required('请选择结束时间'),
        price: yup.number().typeError('请输入价格').required('请输入价格'),
        original_price: yup.number().typeError('请输入原价').required('请输入原价'),
        max_enrollment_number: yup.number().typeError('请输入人数').required('请输入人数'),
        slogan: yup.string().max(200).required('请输入训练营Slogan')
    })

    const formik = useFormik<{ name: string, begin_time: Date | null, end_time: Date | null, price: number | string | null, max_enrollment_number: number | string | null, slogan: string, cover: string ,original_price: number|string|null}>({
        initialValues: {
            name: '',
            begin_time: null,
            end_time: null,
            price: '',
            original_price: '',
            max_enrollment_number: '',
            slogan: '',
            cover: ''
        },
        validationSchema: validationSchema,
        onSubmit: handleSubmit
    })

    return <React.Fragment>
        <Container>
            <form onSubmit={formik.handleSubmit}>
                <Box display="flex" justifyContent="space-between" mb={2}>
                    <Box>
                        <Typography variant="h6">创建训练营</Typography>
                    </Box>
                    <Box>
                        <Button type="submit">提交</Button>
                    </Box>
                </Box>
                <Paper>
                    <Box p={4}>
                        <Box mb={3}>
                            <Typography>封面图</Typography>
                            <Box width="125px" height="93px" mt={1} position="relative">
                                <div {...getRootProps({ className: 'dropzone' })} style={{ minHeight: '93px', border: '1px dashed #e1e1e1', borderRadius: '4px' }}>
                                    <input {...getInputProps()} />
                                    <Typography variant="caption" align="center">点击或拖拽封面图至此</Typography>
                                </div>
                                {formik.values.cover && <img src={formik.values.cover} style={{ position: 'absolute', top: '0', left: '0', pointerEvents: 'none', cursor: 'pointer', width: '100%', height: '100%' }} />}
                                {uploadImg && <Box display="flex" alignItems="center" justifyContent="center" style={{ position: 'absolute', top: '0', left: '0', width: '100%', height: '100%' }}>
                                    <CircularProgress size={24} />
                                </Box>}
                            </Box>
                        </Box>
                        <Grid container>
                            <Grid item md={12} xs={12}>
                                <Box pb={3}>
                                    <TextField
                                        id="name"
                                        name="name"
                                        value={formik.values.name}
                                        onChange={formik.handleChange}
                                        error={formik.touched.name && Boolean(formik.errors.name)}
                                        helperText={formik.touched.name && formik.errors.name}
                                        label="训练营名称"
                                        variant="outlined"
                                        size="small"
                                        fullWidth />
                                </Box>
                            </Grid>
                            <Grid item md={12} xs={12}>
                                <Box pb={3}>
                                    <TextField
                                        label="Slogan"
                                        id="slogan"
                                        name="slogan"
                                        value={formik.values.slogan} onChange={formik.handleChange}
                                        error={Boolean(formik.errors.slogan && formik.touched.slogan)}
                                        helperText={formik.touched.slogan && formik.errors.slogan}
                                        variant="outlined"
                                        size="small"
                                        fullWidth />
                                </Box>
                            </Grid>
                            <Grid item md={3}>
                                <Box pb={3} mr={2}>
                                    <TextField
                                        label="价格"
                                        id="price"
                                        name="price"
                                        type="number"
                                        value={formik.values.price}
                                        onChange={formik.handleChange}
                                        error={Boolean(formik.errors.price && formik.touched.price)}
                                        helperText={formik.touched.price && formik.errors.price}
                                        variant="outlined"
                                        size="small"
                                        fullWidth />
                                </Box>
                            </Grid>
                            <Grid item md={3}>
                                <Box pb={3} mr={2}>
                                    <TextField
                                        label="原价"
                                        id="original_price"
                                        name="original_price"
                                        type="number"
                                        value={formik.values.original_price}
                                        onChange={formik.handleChange}
                                        error={Boolean(formik.errors.original_price && formik.touched.original_price)}
                                        helperText={formik.touched.original_price && formik.errors.original_price}
                                        variant="outlined"
                                        size="small"
                                        fullWidth />
                                </Box>
                            </Grid>
                            <Grid item md={3}>
                                <Box pb={3}>
                                    <TextField
                                        label="人数"
                                        id="max_enrollment_number"
                                        name="max_enrollment_number"
                                        type="number"
                                        value={formik.values.max_enrollment_number}
                                        onChange={formik.handleChange}
                                        error={Boolean(formik.errors.max_enrollment_number && formik.touched.max_enrollment_number)}
                                        helperText={formik.touched.max_enrollment_number && formik.errors.max_enrollment_number}
                                        variant="outlined"
                                        size="small"
                                        fullWidth />
                                </Box>
                            </Grid>
                            <Grid item md={12}></Grid>

                            <Grid item md={3}>
                                <Box mb={3} mr={2}>
                                    <DateTimePicker
                                        label="开始时间"
                                        inputVariant="outlined"
                                        size="small"
                                        clearable
                                        minDate={new Date()}
                                        format="yyyy-MM-dd HH:mm"
                                        value={formik.values.begin_time}
                                        error={Boolean(formik.errors.begin_time && formik.touched.begin_time)}
                                        helperText={formik.touched.begin_time && formik.errors.begin_time}
                                        onChange={(date: Date | null) => {
                                            formik.setFieldValue('begin_time', date)
                                        }}
                                        fullWidth
                                    />
                                </Box>
                            </Grid>
                            <Grid item md={3}>
                                <DateTimePicker
                                    label="结束时间"
                                    inputVariant="outlined"
                                    size="small"
                                    clearable
                                    fullWidth
                                    format="yyyy-MM-dd HH:mm"
                                    value={formik.values.end_time}
                                    error={Boolean(formik.errors.end_time && formik.touched.end_time)}
                                    helperText={formik.touched.end_time && formik.errors.end_time}
                                    onChange={(date: Date | null) => {
                                        formik.setFieldValue('end_time', date)
                                    }}
                                />
                            </Grid>
                            <Grid item md={12}>
                                <Box borderRadius={4} border="1px solid #d1d1d1">
                                    <BraftEditor media={{ uploadFn: handleEditorUpload }} value={editorState} onChange={hanldeEditorChange} />
                                </Box>
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
            </form>
        </Container>
    </React.Fragment>
}

export default CreateCoachCamp